import React, { useContext, useState } from "react";
import "./Cart_details_card.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMinus, faPlus, faXmark } from "@fortawesome/free-solid-svg-icons";
import Cookies from "js-cookie";
import { Context } from "../../../utils/context";
import {
  CartQuantity,
  deleteCartLuxury,
  getCartLuxury,
} from "../../../utils/luxuryapis/addToCart/addToCart";
import { useNavigate } from "react-router-dom";
function Cart_details_card({ data, IMG_URL, getAllData }) {
  const [qty, setQty] = useState(1);

  const [error, setError] = useState(1);
  const navigate = useNavigate();
  const [isRemoved, setIsRemoved] = useState(false);
  const { signin } = useContext(Context);
  // Increase quantity
  const handleIncrease = () => {
    setQty((prev) => prev + 1);
  };

  // Decrease quantity (minimum 1)
  const handleDecrease = () => {
    if (qty > 1) {
      setQty((prev) => prev - 1);
    }
  };

  // Remove item
  const handleRemove = () => {
    setIsRemoved(true);
  };

  // If removed, don't render card
  if (isRemoved) return null;

  const mrp = Number(data?.product_quantity?.mrp || 0);
  const price = Number(data?.product_quantity?.price || 0);
  const discount = mrp > 0 ? Math.round(((mrp - price) / mrp) * 100) : 0;

  const addCartQuantity = async (id, type) => {
   
    if (
      type === "add" &&
      Number(data?.quantity) + 1 > Number(data?.product_quantity?.unit)
    ) {
      setError(`Only ${data?.product_quantity?.unit} stock available`);
      return;
    }
    setError("");
    await CartQuantity(id, type);
    await getAllData();
  };

  const deleteCart = async (id) => {
    await deleteCartLuxury(id);
    await getAllData();
  };
  return (
    <>
      <section className="Cart_details_card">
        <div className="row">
          <div className="col-lg-2 col-sm-4 col-6">
            <div className="img_holder">
              <div>
                <img
                  src={IMG_URL + data?.product_variant?.product_images[0]?.image}
                  alt="product"
                  className="product_img"
                />
              </div>
            </div>
          </div>

          <div className="col-lg-10">
            <div className="row row_holder">
              <div className="col-12">
                <div className="heading_holder">
                  <h4>{data?.product?.name}</h4>
                </div>
              </div>

              <div className="col-md-4 col-sm-4 ">
                <div className="product_details">
                  <div className="text_holder">
                    {error && (
                      <span style={{ color: "red", fontSize: "14px" }}>
                        {error}
                      </span>
                    )}
                    <p>Colour : {data?.product_variant?.v_name}</p>
                    <p>Size : {data?.product_quantity?.name}</p>
                    <p>Ref. {data?.product?.hsn_code}</p>
                  </div>
                </div>
              </div>

              <div className="col-md-4 col-sm-4 d_none_holder">
                <div className="card_btn_holder">
                  <div className="inc_dec_btn_holder">
                    <div
                      className="sign_holder"
                      onClick={() => addCartQuantity(data?.id, "minus")}
                      style={{
                        opacity: qty === 1 ? 0.5 : 1,
                        cursor: qty === 1 ? "not-allowed" : "pointer",
                      }}
                    >
                      <FontAwesomeIcon icon={faMinus} />
                    </div>

                    <div className="sign_holder">{data?.quantity}</div>

                    <div
                      className="sign_holder"
                      onClick={() => addCartQuantity(data?.id, "add")}
                      style={{ cursor: "pointer" }}
                    >
                      <FontAwesomeIcon icon={faPlus} />
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-md-4 col-sm-4 d_none_holder">
                <div className="ammount_product_details">
                  <div className="text_holder">
                    <p>MRP: ₹ {data?.product_quantity?.mrp}</p>
                    <p className="selling_price">
                      Selling Price: ₹ {data?.product_quantity?.price}{" "}
                    </p>
                    <p className="discount_price">{discount}% Discount</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* REMOVE ICON */}
        <FontAwesomeIcon
          className="remove_icon d_none_holder"
          icon={faXmark}
          onClick={() => deleteCart(data?.id, "add")}
          // onClick={handleRemove}
          style={{ cursor: "pointer" }}
        />
      </section>
      <hr />
    </>
  );
}

export default Cart_details_card;
